import { render } from "./ActiveHygieneCert.vue?vue&type=template&id=5f8aba8e&scoped=true"
import script from "./ActiveHygieneCert.vue?vue&type=script&lang=js"
export * from "./ActiveHygieneCert.vue?vue&type=script&lang=js"

import "./ActiveHygieneCert.vue?vue&type=style&index=0&id=5f8aba8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8aba8e"]])

export default __exports__